import Mapbox from 'index.vue';
import { BaseLocationsLayer } from './baseLocationsLayer';

export class ScenarioLocationsLayer extends BaseLocationsLayer {
    constructor(mapboxInstance: InstanceType<typeof Mapbox>) {
        super(mapboxInstance, '', 'scenarioLocations-layer', 'scenarioLocations-source','symbol', {
            'icon-image': ['get', 'url'],
            'icon-size': ['/', ['get', 'size'], 1],
            'icon-allow-overlap': true,
            'icon-anchor': 'top-left',
            'icon-offset':
                [-20, ['+', -20, ['get', 'offset']]
                ],

            'symbol-sort-key': ['get', 'zIndex'],
        }, {},true); 
        mapboxInstance.map.on('click', this.layerName, (e: any) => {
            this.mapboxInstance.$emit('scenarioLocationLeftClick', { scenarioLocation: JSON.parse(e.features[0].properties.scenarioLocation) });
        });
    }
    
    public DataChanged = async () => {
        if (this.mapboxInstance.scenarioLocationsVisible) {
            const uniqueUrls = new Set<string>();
            this.mapboxInstance.scenarioLocations.forEach((location: any) => {
                const normalUrl = this.GetLocationIcon(this.mapboxInstance.model, location, false, true).url;
                const selectedUrl = this.GetLocationIcon(this.mapboxInstance.model, location, true, true).url;
                uniqueUrls.add(normalUrl);
                uniqueUrls.add(selectedUrl);
            });
            const loadImagePromises = super.LoadImages(uniqueUrls);
            const features = this.mapboxInstance.scenarioLocations.map((scenarioLocation: any) => {
                return {
                    type: 'Feature',
                    geometry: {
                        type: 'Point',
                        coordinates: [scenarioLocation.lng, scenarioLocation.lat] as [number, number],
                    },
                    properties: {
                        ...this.GetLocationIcon(this.mapboxInstance.model, scenarioLocation, false, true),
                        scenarioLocation: scenarioLocation,
                        title: scenarioLocation.scenarioName + ' - ' + scenarioLocation.locationName,
                    }

                }
            });
            await Promise.all(loadImagePromises);
            super.SetFeatures(features);
        }
        else {
            super.SetFeatures([]);
        }
    };
}